<template>
    <div  class="page update-page">
        <Header title="修改基本信息" :show-back="true" class="nav" />
        <div class="content">
    <div v-if="$store.state.user.userRole=='01'">
        <van-form :show-error="false"  @submit="submit">
          <div class="register-field">
            <div class="register-field-title">头像</div>
            <!-- <div class="field-btn">下载申请表</div> -->
            <van-uploader
              v-model="imgList"
              preview-size='25vw'
              :max-count='1'
              :after-read="afterRead"
              >
            </van-uploader>
          </div>
          <van-field v-model="params.userMail" label="邮箱"
            placeholder="请输入邮箱"
            :rules="rules.checkEmailRule" />
          <van-field
            readonly
            clickable
            label="城市"
            :value="value"
            placeholder="选择城市"
            @click="handleChooseCity"
            :rules="[{ required: true, message: '请选择城市' }]"
          />
          <van-field v-model="params.detailAddress" label="详细地址"
            placeholder="请输入详细地址"
            :rules="[{ required: true, message: '请输入详细地址' }]" />
            <div style="margin: 16px;">
              <van-button color="#00545e" block type="info" native-type="submit">确认修改</van-button>
            </div>
        </van-form>
    </div>
    <div v-else>
        <van-form :show-error="false" @submit="submit">
          <div class="register-field">
            <div class="register-field-title">头像</div>
            <!-- <div class="field-btn">下载申请表</div> -->
            <van-uploader
              v-model="imgList"
              preview-size='25vw'
              :max-count='1'
              :after-read="afterRead"
              >
            </van-uploader>
          </div>
          <van-field v-model="params.userName" label="姓名"
            placeholder="请输入姓名"
            :rules="[{ required: true, message: '请输入姓名' }]" />

            <div style="margin: 16px;">
              <van-button color="#00545e" block type="info" native-type="submit">确认修改</van-button>
            </div>

        </van-form>
    </div>
        </div>

        <van-popup v-model="showPicker" round position="bottom">
          <ChooseCity @cancleChooseCity="cancleChooseCity" @submitAddress="submitAddress"></ChooseCity>
        </van-popup>

        <van-overlay :show="hintOverlay" @click="hintOverlay = false">
          <div class="wrapper-overlay" @click.stop>
            <div class="content-overlay">
              <div class="overlay-cancel" @click="hintOverlay = false">x</div>
              <div class="content-title">是否修改信息？</div>
              <div class="overlay-block"></div>
              <div class="overlay-btn" @click="hintOverlay = false">取消</div>
              <div class="overlay-btn" @click="updateSuccess()">确定</div>
              <!-- <img src="../dialog-bg.png"></img> -->
            </div>
          </div>
        </van-overlay>
    </div>
</template>

<script>
import Header from '@/components/header'
import centerApi from '../../api/center'
import fileApi from '../../api/file'
import { commonUtils } from '@/utils/common'
import ChooseCity from '../login/choose-city.vue'
import validators from '@/utils/validators'

export default {
  components: {
    Header,
    ChooseCity
  },
  data () {
    var checkEmail = validators.checkEmail
    return {
      params: {
        applyType: '01',
        verifyCode: '',
        applyInviteCode: '',
        clientName: '',
        contactPerson: '',
        contactMobile: '',
        detailAddress: '',
        userMail: '',
        userName: '',
        avatarImageId: ''
      },
      detailAddress: '',
      showArea: false,
      areaList: {},

      showPicker: false,
      value: '',
      fileList: [],
      disableSendBtn: false,
      countDownIndex: 0,
      hintOverlay: false,
      clientList: [],
      userInfo: {},
      imgList: [],
      changeCity: false,
      rules: {
        checkEmailRule: [{ required: true, validator: checkEmail, message: '请输入正确的邮箱格式' }]
      }
    }
  },
  computed: {

    countDownText () {
      return this.countDownIndex > 0 ? '(' + this.countDownIndex + ')' : ''
    }
  },
  created () {
    this.getClientInfo()
  },
  methods: {
    getImageUrl: commonUtils.getImageUrl,
    getClientInfo () {
      centerApi.getClientInfo().then(res => {
        if (res.data.resultCode === '0') {
          this.userInfo = res.data.resultData.clientInfo
          this.params.userMail = this.userInfo.clientUserDTO.userMail
          this.params.detailAddress = this.userInfo.detailAddress
          this.params.avatarImageId = this.userInfo.avatarImageId
          this.value = `${this.userInfo.provinceName || ''} ${this.userInfo.cityName || ''} ${this.userInfo.countyName || ''}`
          this.params.userName = this.userInfo.clientUserDTO.userName
          this.params.provinceId = this.userInfo.provinceId
          this.params.cityId = this.userInfo.cityId
          this.params.countyId = this.userInfo.countyId || ''
        }
      })
    },
    gotoLogin (contactMobile, clientId) {
      this.$router.push({ name: 'login2', query: { contactMobile, clientId } })
    },
    handleRegisterCheck () {
      centerApi.registerCheck(this.params).then(res => {
        if (res.data.resultCode === '0') {
          if (res.data.resultData.clientList) {
            this.clientList = res.data.resultData.clientList
            this.selectOverlay = true
          }
        }
      })
    },
    handleChooseCity () {
      this.changeCity = true
      this.showPicker = true
    },
    getVerifyCode () {
      if (this.disableSendBtn) {
        return
      }
      let params = {
        phoneNumber: this.params.contactMobile
      }
      centerApi.publicRegisterVerifyCode(params).then(res => {
        if (res.data.resultCode === '0') {
          this.countDownIndex = 60
          this.disableSendBtn = true
          this.countDown()
        }
      })
    },
    countDown () {
      this.countDownIndex = 60
      let _vm = this
      let timer = setInterval(() => {
        _vm.countDownIndex--
        if (_vm.countDownIndex === 0) {
          _vm.disableSendBtn = false
          clearInterval(timer)
        }
      }, 1000)
    },
    afterRead (file) {
      fileApi
        .uploadFilePublic(file.file)
        .then((response) => {
          if (response.data.resultCode === '0') {
            let fileDTO = response.data.resultData.fileDTO
            this.params.avatarImageId = fileDTO.fileId
          }
        })
        .catch(() => {
        })
    },
    submitAddress (params) {
      this.params.provinceId = params.provinceId
      this.params.cityId = params.cityId
      this.params.countyId = params.countyId || ''
      this.value = params.value
      this.showPicker = false
    },
    handleCancelAddress () {
      this.value = ''
      this.showPicker = false
    },
    submit () {
      this.hintOverlay = true
    },
    updateSuccess () {
      centerApi.clientUserUpdateUserBasic(this.params).then(res => {
        if (res.data.resultCode === '0') {
          this.hintOverlay = false
          setTimeout(() => {
            this.$router.push({ name: 'personal-data' })
          }, 1000)
          if (res.data.resultData.popUpStatus === 1) {
            this.$toast('恭喜完成资料完善任务，获得+300 易加积分!')
          } else {
            this.$toast('修改成功！')
          }
        }
      })
      this.hintOverlay = false
    },
    cancleChooseCity () {
      this.showPicker = false
    }
  }
}
</script>
<style lang="less" scoped>
.register-field{
  margin:20px  15px 0px 15px ;
  .register-field-title{
    font-weight:bolder;
    font-size: 16px;
  }
}
.field-btn{
  position: absolute;
  right: 15px;
  line-height: 40px;
  color:#00545e
}
.notice-bar{
  display: flex;
  background-color: rgb(238, 236, 203);
  padding: 6px 10px;
  color: rgb(182, 157, 16);
  margin:15px;
  width: calc(100% - 50px);
  border-radius: 5px;
  justify-content: space-between;
}
.upload-icon{

  width: 40px;
  height: 40px;
  border-radius: 8px;
  border: dashed 2px rgb(190, 190, 190);
  font-size: 30px;
  text-align: center;
  color: rgb(190, 190, 190);
}
.van-uploader{
  margin-top: 15px;
}
.wrapper-overlay{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}
.content-overlay{
  background-image: url(../../assets/images/dialog-bg.png);
  background-size: 100%;
  background-repeat: no-repeat;
  width: 80%;
  background-color: #fff;
  border-radius: 14px;
  img{
    width: 100%;
  }
  .overlay-cancel{
    color: #fff;
    font-size: 80px;
    position: absolute;
    right: 0px;
  }
  .content-title{
    font-size: 19px;
    text-align: center;
    color: white;
    margin: 25px 0 15px 0;
  }
  .content-info{
    background-color: rgb(255, 255, 255);
    width: 86%;
    margin-left: 7%;
    z-index: 10;
    border-radius: 5px;
    text-align: center;
    line-height: 30px;
    font-size: 16px;
    box-shadow: 0px 0px 0px 0px #f1f1f1,
    0px 0px 2px 0px #f1f1f1,
    0px 0px 2px 0px #f1f1f1,
    0px 2px 13px 0px #f1f1f1;
    .overlay-icon{
      padding-top: 20px;
    }
  }
    .overlay-btn{
    text-align: center;
    font-size: 18px;
    color: var(--base-green);
    padding: 15px 0 20px 0;
    display: inline-block;
    width: 50%;
  }
  .content-info-client{
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    text-align: left !important;
    color: var(--base-green);
    font-size: 14px;
    padding-left: 10px;
  }

  .content-info-client-name{
    font-weight: 600;
  }
  .content-info-client-right{
    font-size: 14px;
    line-height: 18px !important;
    padding: 15px 10px 0 0 ;
  }
  .content-info-client-code{
    font-size: 12px;
  }
}
</style>
